export const getConversionMeta = (conversionType) => {
  const baseUrl = 'https://iconvertify.com';
  const metaData = {
    pdfToWord: {
      title: 'Convert PDF to Word | Free Online PDF to DOCX Converter - iconvertify',
      description: 'Convert PDF to Word documents online for free. Maintain formatting, images, and text quality. Easy-to-use PDF to DOCX converter with instant download.',
      keywords: 'pdf to word, convert pdf to docx, pdf converter, document conversion, free pdf converter, online pdf to word, pdf to docx online',
      canonical: '/convert/pdf-to-word',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to Word Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "1250"
        },
        "featureList": [
          "Free conversion",
          "Maintains original formatting",
          "Secure file processing",
          "No registration required",
          "Instant download"
        ],
        "applicationSuite": "iconvertify",
        "downloadUrl": `${baseUrl}/convert/pdf-to-word`,
        "browserRequirements": "Requires modern web browser",
        "softwareVersion": "1.0"
      },
      openGraph: {
        title: 'Convert PDF to Word Online Free | iconvertify',
        description: 'Transform PDF files to editable Word documents instantly. Free, secure, and no registration required.',
        image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`,
        type: 'website',
        url: `${baseUrl}/convert/pdf-to-word`
      },
      twitter: {
        card: 'summary_large_image',
        title: 'PDF to Word Converter | Free Online Tool',
        description: 'Convert PDF to Word documents online. Free, fast, and secure.',
        image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`
      }
    },
    wordToPdf: {
      title: 'Convert Word to PDF | Free DOCX to PDF Converter - iconvertify',
      description: 'Transform Word documents to PDF format online for free. Preserve formatting and layout. Quick and secure DOCX to PDF conversion.',
      keywords: 'word to pdf, convert docx to pdf, doc converter, document conversion, free word converter',
      canonical: '/convert/word-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Word to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    excelToPdf: {
      title: 'Convert Excel to PDF | Free XLSX to PDF Converter - iconvertify',
      description: 'Convert Excel spreadsheets to PDF format online. Preserve formatting, charts, and layout. Free and secure XLSX to PDF conversion.',
      keywords: 'excel to pdf, convert xlsx to pdf, spreadsheet converter, excel converter, xlsx to pdf',
      canonical: '/convert/excel-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Excel to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pdfToExcel: {
      title: 'Convert PDF to Excel | Free PDF to XLSX Converter - iconvertify',
      description: 'Convert PDF documents to Excel spreadsheets online. Extract tables and data with accuracy. Free PDF to XLSX conversion tool.',
      keywords: 'pdf to excel, convert pdf to xlsx, pdf converter, spreadsheet converter, pdf to spreadsheet',
      canonical: '/convert/pdf-to-excel',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to Excel Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pptToPdf: {
      title: 'Convert PowerPoint to PDF | Free PPT to PDF Converter - iconvertify',
      description: 'Convert PowerPoint presentations to PDF format online. Maintain animations, transitions, and formatting. Free and secure PPT to PDF conversion.',
      keywords: 'powerpoint to pdf, convert ppt to pdf, presentation converter, pptx converter',
      canonical: '/convert/ppt-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PowerPoint to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pdfToPpt: {
      title: 'Convert PDF to PowerPoint | Free PDF to PPTX Converter - iconvertify',
      description: 'Convert PDF documents to PowerPoint presentations online. Extract content and create editable slides. Free PDF to PPTX conversion tool.',
      keywords: 'pdf to powerpoint, convert pdf to pptx, pdf converter, presentation converter, pdf to ppt',
      canonical: '/convert/pdf-to-ppt',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to PowerPoint Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    textToPdf: {
      title: 'Convert Text to PDF | Free TXT to PDF Converter - iconvertify',
      description: 'Convert plain text files to PDF format online. Preserve formatting and layout. Free and secure text to PDF conversion.',
      keywords: 'text to pdf, convert txt to pdf, text converter, document converter, txt to pdf',
      canonical: '/convert/text-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Text to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pdfToText: {
      title: 'Convert PDF to Text | Free PDF to TXT Converter - iconvertify',
      description: 'Extract text from PDF documents online. Convert PDF to plain text format with accuracy. Free PDF to TXT conversion tool.',
      keywords: 'pdf to text, convert pdf to txt, pdf converter, text extractor, pdf to plain text',
      canonical: '/convert/pdf-to-text',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to Text Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    mdToPdf: {
      title: 'Convert Markdown to PDF | Free MD to PDF Converter - iconvertify',
      description: 'Convert Markdown documents to PDF format online. Preserve formatting and styling. Free MD to PDF conversion tool.',
      keywords: 'markdown to pdf, convert md to pdf, markdown converter, document converter, md to pdf',
      canonical: '/convert/md-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Markdown to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pdfToMd: {
      title: 'Convert PDF to Markdown | Free PDF to MD Converter - iconvertify',
      description: 'Convert PDF documents to Markdown format online. Extract content and structure. Free PDF to MD conversion tool.',
      keywords: 'pdf to markdown, convert pdf to md, pdf converter, markdown converter, pdf to md',
      canonical: '/convert/pdf-to-md',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to Markdown Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    htmlToPdf: {
      title: 'Convert HTML to PDF | Free HTML to PDF Converter - iconvertify',
      description: 'Convert HTML files to PDF format online. Preserve web page layout and styling. Free HTML to PDF conversion tool.',
      keywords: 'html to pdf, convert html to pdf, html converter, web to pdf, html to pdf online',
      canonical: '/convert/html-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "HTML to PDF Converter",
        "applicationCategory": "Document Converter",
        "operatingSystem": "Web Browser"
      }
    },
    // Image conversions
    svgToPng: {
      title: 'Convert SVG to PNG | Free Vector to Image Converter - iconvertify',
      description: 'Convert SVG vector graphics to PNG format online. High-quality image conversion with transparency support. Free SVG to PNG converter.',
      keywords: 'svg to png, vector to image, convert svg, image converter',
      canonical: '/convert/svg-to-png',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "SVG to PNG Converter",
        "applicationCategory": "Image Converter",
        "operatingSystem": "Web Browser"
      }
    },
    jpegToPng: {
      title: 'Convert JPEG to PNG | Free Image Converter - iconvertify',
      description: 'Convert JPEG/JPG images to PNG format online. Preserve image quality with transparency support. Fast and free JPEG to PNG conversion.',
      keywords: 'jpeg to png, jpg to png, image converter, convert jpeg, photo converter',
      canonical: '/convert/jpeg-to-png',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "JPEG to PNG Converter",
        "applicationCategory": "Image Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pngToJpeg: {
      title: 'Convert PNG to JPEG | Free PNG to JPG Converter - iconvertify',
      description: 'Convert PNG images to JPEG format online. Optimize file size while maintaining quality. Free PNG to JPG conversion tool.',
      keywords: 'png to jpeg, png to jpg, image converter, convert png, photo converter',
      canonical: '/convert/png-to-jpeg',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PNG to JPEG Converter",
        "applicationCategory": "Image Converter",
        "operatingSystem": "Web Browser"
      }
    },
    gifToPng: {
      title: 'Convert GIF to PNG | Free Animated Image Converter - iconvertify',
      description: 'Convert GIF animations to PNG images online. Extract frames and save as high-quality PNG files. Free GIF to PNG converter.',
      keywords: 'gif to png, convert gif, animated image converter, gif converter',
      canonical: '/convert/gif-to-png',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "GIF to PNG Converter",
        "applicationCategory": "Image Converter",
        "operatingSystem": "Web Browser"
      }
    },
    webpToPng: {
      title: 'Convert WebP to PNG | Free Modern Image Converter - iconvertify',
      description: 'Convert WebP images to PNG format online. Maintain quality and transparency. Free WebP to PNG conversion tool.',
      keywords: 'webp to png, convert webp, google image format, webp converter',
      canonical: '/convert/webp-to-png',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "WebP to PNG Converter",
        "applicationCategory": "Image Converter",
        "operatingSystem": "Web Browser"
      }
    },
    // Archive conversions
    zipToRar: {
      title: 'Convert ZIP to RAR | Free Archive Converter - iconvertify',
      description: 'Convert ZIP archives to RAR format online. Compress and convert archives with ease. Free ZIP to RAR conversion tool.',
      keywords: 'zip to rar, convert zip, archive converter, compression converter',
      canonical: '/convert/zip-to-rar',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "ZIP to RAR Converter",
        "applicationCategory": "Archive Converter",
        "operatingSystem": "Web Browser"
      }
    },
    sevenZToZip: {
      title: 'Convert 7Z to ZIP | Free Archive Format Converter - iconvertify',
      description: 'Convert 7Z archives to ZIP format online. Easy-to-use compression converter. Free 7Z to ZIP conversion tool.',
      keywords: '7z to zip, convert 7zip, archive converter, compression format',
      canonical: '/convert/7z-to-zip',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "7Z to ZIP Converter",
        "applicationCategory": "Archive Converter",
        "operatingSystem": "Web Browser"
      }
    },
    rarToZip: {
      title: 'Convert RAR to ZIP | Free Archive Converter - iconvertify',
      description: 'Convert RAR archives to ZIP format online. Extract and convert compressed files. Free RAR to ZIP conversion tool.',
      keywords: 'rar to zip, convert rar, archive converter, compression converter, rar to zip online',
      canonical: '/convert/rar-to-zip',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "RAR to ZIP Converter",
        "applicationCategory": "Archive Converter",
        "operatingSystem": "Web Browser"
      }
    },
    zipToSevenZip: {
      title: 'Convert ZIP to 7Z | Free Archive Format Converter - iconvertify',
      description: 'Convert ZIP archives to 7Z format online. Better compression and file management. Free ZIP to 7Z conversion tool.',
      keywords: 'zip to 7z, convert zip to 7zip, archive converter, compression format, zip to 7z online',
      canonical: '/convert/zip-to-7z',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "ZIP to 7Z Converter",
        "applicationCategory": "Archive Converter",
        "operatingSystem": "Web Browser"
      }
    },
    epubToPdf: {
      title: 'Convert EPUB to PDF | Free Ebook Converter - iconvertify',
      description: 'Convert EPUB ebooks to PDF format online. Preserve formatting and layout. Free EPUB to PDF conversion tool.',
      keywords: 'epub to pdf, convert epub, ebook converter, epub converter, epub to pdf online',
      canonical: '/convert/epub-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "EPUB to PDF Converter",
        "applicationCategory": "Ebook Converter",
        "operatingSystem": "Web Browser"
      }
    },
    pdfToEpub: {
      title: 'Convert PDF to EPUB | Free Ebook Converter - iconvertify',
      description: 'Convert PDF documents to EPUB ebook format online. Create reflowable ebooks. Free PDF to EPUB conversion tool.',
      keywords: 'pdf to epub, convert pdf to epub, ebook converter, pdf converter, pdf to epub online',
      canonical: '/convert/pdf-to-epub',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "PDF to EPUB Converter",
        "applicationCategory": "Ebook Converter",
        "operatingSystem": "Web Browser"
      }
    },
    mp4ToMp3: {
      title: 'Convert MP4 to MP3 | Free Audio Extractor - iconvertify',
      description: 'Extract audio from MP4 videos online. Convert MP4 to MP3 format with high quality. Free MP4 to MP3 conversion tool.',
      keywords: 'mp4 to mp3, convert mp4 to mp3, audio extractor, video to audio, mp4 to mp3 online',
      canonical: '/convert/mp4-to-mp3',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "MP4 to MP3 Converter",
        "applicationCategory": "Audio Converter",
        "operatingSystem": "Web Browser"
      }
    },
    // Data format conversions
    csvToJson: {
      title: 'Convert CSV to JSON | Free Data Format Converter - iconvertify',
      description: 'Convert CSV files to JSON format online. Easy data transformation with accurate field mapping. Free CSV to JSON converter.',
      keywords: 'csv to json, convert csv, data converter, spreadsheet to json',
      canonical: '/convert/csv-to-json',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "CSV to JSON Converter",
        "applicationCategory": "Data Converter",
        "operatingSystem": "Web Browser"
      }
    },
    jsonToCsv: {
      title: 'Convert JSON to CSV | Free Data Converter - iconvertify',
      description: 'Convert JSON data to CSV format online. Transform complex JSON structures into spreadsheet-ready CSV files. Free JSON to CSV converter.',
      keywords: 'json to csv, convert json, data converter, json to spreadsheet',
      canonical: '/convert/json-to-csv',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "JSON to CSV Converter",
        "applicationCategory": "Data Converter",
        "operatingSystem": "Web Browser"
      }
    },
    // CAD conversions
    dwgToPdf: {
      title: 'Convert DWG to PDF | Free CAD Drawing Converter - iconvertify',
      description: 'Convert AutoCAD DWG files to PDF format online. Preserve drawing quality and scale. Free DWG to PDF converter.',
      keywords: 'dwg to pdf, convert autocad, cad converter, drawing converter',
      canonical: '/convert/dwg-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "DWG to PDF Converter",
        "applicationCategory": "CAD Converter",
        "operatingSystem": "Web Browser"
      }
    },
    dxfToPdf: {
      title: 'Convert DXF to PDF | Free CAD File Converter - iconvertify',
      description: 'Convert DXF files to PDF format online. Maintain vector quality and measurements. Free DXF to PDF converter.',
      keywords: 'dxf to pdf, convert dxf, cad converter, technical drawing converter',
      canonical: '/convert/dxf-to-pdf',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "DXF to PDF Converter",
        "applicationCategory": "CAD Converter",
        "operatingSystem": "Web Browser"
      }
    },
    // Video/Audio conversions
    aviToMp4: {
      title: 'Convert AVI to MP4 | Free Video Converter - iconvertify',
      description: 'Convert AVI videos to MP4 format online. Maintain video quality with optimized compression. Free AVI to MP4 converter.',
      keywords: 'avi to mp4, convert avi, video converter, video format converter',
      canonical: '/convert/avi-to-mp4',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "AVI to MP4 Converter",
        "applicationCategory": "Video Converter",
        "operatingSystem": "Web Browser"
      }
    },
    mp4ToGif: {
      title: 'Convert MP4 to GIF | Free Video to Animation Converter - iconvertify',
      description: 'Convert MP4 videos to animated GIF format online. Create shareable animations from your videos. Free MP4 to GIF converter.',
      keywords: 'mp4 to gif, convert video to gif, animation converter, gif maker',
      canonical: '/convert/mp4-to-gif',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "MP4 to GIF Converter",
        "applicationCategory": "Video Converter",
        "operatingSystem": "Web Browser"
      }
    },
    mp3ToMp4: {
      title: 'Convert MP3 to MP4 | Free Audio to Video Converter - iconvertify',
      description: 'Convert MP3 audio files to MP4 video format online. Add static image to audio tracks. Free MP3 to MP4 converter.',
      keywords: 'mp3 to mp4, convert audio to video, audio converter, mp3 converter',
      canonical: '/convert/mp3-to-mp4',
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "MP3 to MP4 Converter",
        "applicationCategory": "Audio Converter",
        "operatingSystem": "Web Browser"
      }
    }
  };

  // Enhanced default metadata - generates metadata from URL if conversion type not found
  const generateMetadataFromUrl = (conversionType) => {
    // Handle undefined, null, empty string, or the string 'default' as homepage
    if (!conversionType || conversionType === 'default') {
      return {
        title: 'Free Online File Converter | iconvertify',
        description: 'Convert files online with our free conversion tools. Support for documents, images, audio, and more.',
        keywords: 'file converter, online converter, free converter',
        canonical: '/',
        schema: {
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "iconvertify File Converter",
          "applicationCategory": "File Converter",
          "operatingSystem": "Web Browser",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          }
        },
        openGraph: {
          title: 'Free Online File Converter | iconvertify',
          description: 'Convert any file format online for free. Fast, secure, and reliable.',
          image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`,
          type: 'website',
          url: `${baseUrl}/`
        },
        twitter: {
          card: 'summary_large_image',
          title: 'Free Online File Converter',
          description: 'Convert any file format online for free',
          image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`
        }
      };
    }

    // Generate metadata from conversion type (e.g., "pdf-to-ppt" -> "PDF to PPT")
    const formatName = (str) => {
      return str
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };

    const displayName = formatName(conversionType);
    return {
      title: `Convert ${displayName} | Free Online Converter - iconvertify`,
      description: `Convert ${displayName} files online for free. Fast, secure, and reliable file conversion. No registration required.`,
      keywords: `${conversionType}, convert ${conversionType}, file converter, online converter, free converter`,
      canonical: `/convert/${conversionType}`,
      schema: {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": `${displayName} Converter`,
        "applicationCategory": "File Converter",
        "operatingSystem": "Web Browser",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        }
      },
      openGraph: {
        title: `Convert ${displayName} Online Free | iconvertify`,
        description: `Convert ${displayName} files online. Free, secure, and no registration required.`,
        image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`,
        type: 'website',
        url: `${baseUrl}/convert/${conversionType}`
      },
      twitter: {
        card: 'summary_large_image',
        title: `${displayName} Converter | Free Online Tool`,
        description: `Convert ${displayName} files online. Free, fast, and secure.`,
        image: `${baseUrl}/favicon-assets/android-chrome-512x512.png`
      }
    };
  };

  return metaData[conversionType] || generateMetadataFromUrl(conversionType);
};

// Helper function to convert conversion type to URL slug
export const getConversionSlug = (conversionType) => {
  // Convert camelCase to kebab-case
  return conversionType
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase();
};

// Helper function to convert URL slug to conversion type
export const getConversionTypeFromSlug = (slug) => {
  // Convert kebab-case to camelCase
  return slug
    .split('-')
    .map((word, index) => 
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
}; 